import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ITrainingType } from "../../../message-models/training-record-type.interface";
import { TrainingType } from "../../../message-models/training-record-type.class";
import { TrainingRecord } from '../../../domain-model/training-record.class';
import { TrainingTypeService } from '../../services/training-type.service';
import { Subscription } from 'rxjs';
import { IDateTimeWithZone } from "../../../common/date-time-with-zone.interface";
import { UntypedFormControl, Validators } from '@angular/forms';
import { DateTimeWithZone } from '../../../common/date-time-with-zone.class';
import { consts } from '../../../common/modals/consts';
import { TrainingRecordsService } from '../../services/training-records.service';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { OurUserService } from '../../../users/services/user.service';
import { IUserInfo } from '../../../users/models/userInfo.interface';

@Component({
  selector: 'app-training-record-editor',
  templateUrl: './training-record-editor.component.html',
  styleUrls: ['./training-record-editor.component.scss']
})
export class TrainingRecordEditorComponent implements OnInit, OnDestroy {
  @Input() editing: boolean = false;
  @Input() trainingRecord: TrainingRecord = new TrainingRecord();
  @Input() trainingTypes: ITrainingType[] = [];
  @Input() isMultipleOperatives: boolean = false;
  @Input() addingNewTrainingType: boolean;
  @Input() saveAttempted: boolean = false;
  @Output() saveTrainingRecordRequested: EventEmitter<any> = new EventEmitter<any>();
  @Output() saveNewTrainingTypeRequested: EventEmitter<ITrainingType> = new EventEmitter<ITrainingType>();
  @Output() addNewTrainingTypeRequested: EventEmitter<boolean> = new EventEmitter<boolean>();
  // selectedTrainingTypeId: string = consts.emptyGuid;
  newTrainingType: TrainingType = new TrainingType();
  saveNewTrainingTypeAttempted: boolean = false;
  newTrainingTypeIdSubscription: Subscription;
  newTrainingTypeValidToSubscription: Subscription;
  selectedMaxDate: Date;
  selectedMinDate: Date;
  cpdHour: UntypedFormControl;
  editingOperativeDetails: boolean = false;
  constructor(private trainingTypeService: TrainingTypeService,

  ) {}

  ngOnInit(): void {

    this.newTrainingTypeIdSubscription = this.trainingTypeService.getSelectedTrainingTypeId().subscribe(id => {
 
      if (id) {
 
        this.trainingRecord.trainingTypeId = id;
        this.selectedTrainingTypeChanged()
      }
    });
    this.newTrainingTypeValidToSubscription = this.trainingTypeService.getSelectedTrainingTypeValidTo().subscribe(date => {
      if (date) {
        this.trainingRecord.validTo = date;
      }
    })
    this.initDates();

  }

  ngOnDestroy() {
    this.trainingTypeService.clearSelectedTrainingTypeId();
    this.trainingTypeService.clearSelectedTrainingTypeValidTo();
    this.newTrainingTypeIdSubscription.unsubscribe();
    this.newTrainingTypeValidToSubscription.unsubscribe();
  }

  get selectedTrainingType(): ITrainingType {
    if (!this.trainingRecord?.trainingTypeId)
      return null;
    return this.trainingTypes.find(t => t.id === this.trainingRecord.trainingTypeId);
  }

  addNewTrainingType() {
    this.addingNewTrainingType = true;
    this.saveNewTrainingTypeAttempted = false;
    this.newTrainingType = new TrainingType();
    this.addNewTrainingTypeRequested.emit(true);
  }

  cancelNewTrainingType() {
    this.addingNewTrainingType = false;
    this.saveNewTrainingTypeAttempted = false;
    this.addNewTrainingTypeRequested.emit(false);
  }

  saveNewTrainingType() {
    this.saveNewTrainingTypeAttempted = true;
    if (!this.newTrainingType.isValid) {
      return;
    }
    this.saveNewTrainingTypeRequested.emit(this.newTrainingType);
    this.addNewTrainingTypeRequested.emit(false);
    this.addingNewTrainingType = false;
  }

  trainingTypeChanged() {
    if (!this.selectedTrainingType?.heldOn?.dateTime)
      return;
    this.trainingRecord.achievedOn.dateTime = this.selectedTrainingType.heldOn.dateTime;
  }

  selectedTrainingTypeChanged() {
    let trainingTypeHeldOn = this.selectedTrainingType.heldOn;
    let trainingTypeValidTo = this.selectedTrainingType.validTo;
    this.trainingRecord.achievedOn = trainingTypeHeldOn == null ? new DateTimeWithZone() : trainingTypeHeldOn;
    this.trainingRecord.validTo = trainingTypeValidTo == null ? new DateTimeWithZone() : trainingTypeValidTo;   
  }

  disableDatesPriorSelected(date: IDateTimeWithZone) {
    let selectedDate = new Date(date.dateTime);
    this.selectedMinDate = new Date(selectedDate.setDate(selectedDate.getDate() + 1));
  }

  disableDatesPostSelected(date: IDateTimeWithZone) {
    let currentDate = new Date();
    let selectedDate = new Date(date.dateTime);
    this.selectedMaxDate = selectedDate < currentDate ? new Date(selectedDate.setDate(selectedDate.getDate() - 1)) : currentDate;
  }


  // Validators.pattern("/^-?\d*[.,]?\d{0,2}$/")
  validateCPD(cpdHour: number) {
    this.cpdHour = new UntypedFormControl(cpdHour, [Validators.min(0)]);

    return this.cpdHour.valid;

  }

  validate(event: any) {
    var t = event.target.value;
    var result = t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 2) : t;

    if (event.keyCode === "8" || event.keyCode === 8) {
      return true;
    } else {
      if (result !== event.target.value) {
        return false;
      }
    }

  }

  initDates() {
    let today = new Date();
    today.setDate(today.getDate() + 1);

    let trainingValidTo = this.trainingRecord?.validTo.dateTime == null ? new DateTimeWithZone({ dateTime: today.toISOString(), timeZone: '' }) : this.trainingRecord?.validTo;
    let trainingAchievedOn = this.trainingRecord?.achievedOn;

    let maxDate = new Date(trainingValidTo.dateTime) < today ? trainingValidTo : new DateTimeWithZone({ dateTime: today.toISOString(), timeZone: '' });
    let minDate = new Date(trainingAchievedOn.dateTime) < today ? trainingAchievedOn : new DateTimeWithZone({ dateTime: today.toISOString(), timeZone: '' });

    this.disableDatesPostSelected(maxDate);
    this.disableDatesPriorSelected(minDate);
  }

}
